import * as React from 'react';

interface Options {
  enabled?: boolean;
  onError?: OnErrorEventHandler;
  onLoad?: (event: Event) => void;
  src?: string;
}

/** Lifted from Chakra's codebase */
function useHasImageLoaded({ src, onLoad, onError, enabled = true }: Options) {
  const isMounted = React.useRef<boolean>();
  const [hasLoaded, setHasLoaded] = React.useState(false);

  React.useEffect(() => {
    if (!src || !enabled) {
      return;
    }

    const image = new window.Image();
    image.src = src;

    image.onload = (event) => {
      if (isMounted.current) {
        setHasLoaded(true);
        onLoad && onLoad(event);
      }
    };

    image.onerror = (event) => {
      if (isMounted.current) {
        setHasLoaded(false);
        onError && onError(event);
      }
    };
  }, [src, onLoad, onError, enabled]);

  React.useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return hasLoaded;
}

export default useHasImageLoaded;
